function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState } from 'react';
import Collapse from 'react-bootstrap/Collapse';
import { Container, Row, Col, InputGroup, Form } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { claimProjectOverviewNoteService } from '@rd-web-markets/shared/dist/services/claim_project_overview/claim_project_overview_notes.service';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date/dateUtils';
import { Button, DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
import ImmutableUnderReviewFormControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ImmutableUnderReviewFormControl';
import UnsavedChangesPrompt from '@rd-web-markets/shared/dist/components/UnsavedChangesPrompt';
const ClaimProjectNotes = _ref => {
  let {
    isImmutableUnderReview,
    report,
    setReport,
    pageAccess
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const dispatch = useDispatch();
  const {
    t
  } = useTranslation();
  const [open, setOpen] = useState(true);
  const [comment, setComment] = useState('');
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const postComment = async () => {
    try {
      const response = await claimProjectOverviewNoteService.create(report.id, {
        note: comment
      });
      report.report_notes.push(response);
      setReport(_objectSpread({}, report));
      setComment('');
      setHasUnsavedChanges(false);
    } catch (e) {
      dispatch(handleError(e));
    }
  };
  const deleteComment = async (noteId, note) => {
    if (window.confirm('Are you sure you wish to delete this comment? ' + note.substring(0, 20) + '...')) {
      try {
        await claimProjectOverviewNoteService.delete(report.id, noteId);
        const indexToRemove = report.report_notes.findIndex(note => note.id === noteId);
        report.report_notes.splice(indexToRemove, 1);
        setReport(_objectSpread({}, report));
      } catch (e) {
        dispatch(handleError(e));
      }
    }
  };
  const extractDate = date => {
    return createTimezonedDate(date).toCustomLocaleDateString();
  };
  const renderComments = () => {
    return (report.report_notes || []).sort((a, b) => a.id && b.id - a.id).map((data, i) => {
      return i !== 0 && renderOneComment(data);
    });
  };
  const renderOneComment = data => {
    if (!data) return;
    return /*#__PURE__*/React.createElement(Row, {
      key: data.id,
      className: "mt-2"
    }, /*#__PURE__*/React.createElement(Col, {
      md: "8"
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-secondary"
    }, data.note)), /*#__PURE__*/React.createElement(Col, {
      md: "auto",
      className: "p-0"
    }, /*#__PURE__*/React.createElement("div", null, extractDate(data.created_at))), /*#__PURE__*/React.createElement(Col, {
      md: "auto"
    }, data.user_id === user.id && /*#__PURE__*/React.createElement(DeleteButton, {
      onClick: () => deleteComment(data.id, data.note)
    })), /*#__PURE__*/React.createElement(Col, {
      md: "auto"
    }, /*#__PURE__*/React.createElement("div", null, data.user_name)));
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UnsavedChangesPrompt, {
    hasUnsavedChanges: hasUnsavedChanges
  }), /*#__PURE__*/React.createElement(Form.Group, {
    className: "mb-2",
    as: Row
  }, /*#__PURE__*/React.createElement(Form.Label, {
    column: "md"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 9
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "8"
  }, /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(ImmutableUnderReviewFormControl, {
    as: "textarea",
    rows: "3",
    placeholder: t('type_a_comment'),
    value: comment,
    onChange: e => {
      setHasUnsavedChanges(true);
      setComment(e.target.value);
    }
  }), /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: isImmutableUnderReview,
    variant: "primary",
    onClick: postComment,
    id: "button-addon2",
    disabled: comment.length === 0,
    className: "ms-1"
  }, t('save_a_new_comment'))))), report.report_notes && /*#__PURE__*/React.createElement("div", {
    id: "example-collapse-text"
  }, renderOneComment(report.report_notes[0])), /*#__PURE__*/React.createElement(Collapse, {
    in: open
  }, /*#__PURE__*/React.createElement("div", {
    id: "example-collapse-text"
  }, renderComments())), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: "8"
  }, /*#__PURE__*/React.createElement(Button, {
    isImmutableUnderReview: isImmutableUnderReview,
    onClick: () => setOpen(!open),
    "aria-controls": "example-collapse-text",
    "aria-expanded": open,
    className: "mt-2",
    variant: "primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18 me-1"
  }, open ? 'arrow_upward' : 'arrow_downward')))))))));
};
export default ClaimProjectNotes;